export enum SortDirection {
  None,
  Ascending,
  Descending,
}
